// src/components/features/AdminDashboard.tsx
import React, { useState, useEffect } from 'react';

const API_BASE_URL = (import.meta as any).env?.VITE_API_BASE_URL || "https://naz-ai-backend.mohammed-f81.workers.dev";

export const AdminDashboard: React.FC = () => {
    const [stats, setStats] = useState<any>(null);
    const [requests, setRequests] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    const fetchData = async () => {
        setLoading(true);
        try {
            const authHeader = `Bearer ${localStorage.getItem('naz_session_id')}`; // Simplified for demo

            const [statsRes, reqRes] = await Promise.all([
                fetch(`${API_BASE_URL}/api/admin/stats`, { headers: { 'Authorization': authHeader } }),
                fetch(`${API_BASE_URL}/api/admin/rare-parts`, { headers: { 'Authorization': authHeader } })
            ]);

            const statsData = await statsRes.json();
            const reqData = await reqRes.json();

            if (statsData.status === 'success') setStats(statsData.stats);
            if (reqData.status === 'success') setRequests(reqData.requests);
        } catch (err) {
            console.error("Admin Fetch Error:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    if (loading) return <div className="text-white p-8">جاري تحميل لوحة التحكم...</div>;

    return (
        <div className="flex flex-col gap-6 p-4">
            <h2 className="text-2xl font-bold text-white mb-2">لوحة التحكم (الإدارة)</h2>

            {/* Stats Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-white/5 border border-white/10 p-4 rounded-2xl">
                    <span className="text-gray-400 text-xs uppercase">إجمالي الطلبات</span>
                    <div className="text-3xl font-bold text-primary mt-1">{stats?.total_requests || 0}</div>
                </div>
                <div className="bg-white/5 border border-white/10 p-4 rounded-2xl">
                    <span className="text-gray-400 text-xs uppercase">المستخدمين المسجلين</span>
                    <div className="text-3xl font-bold text-white mt-1">{stats?.total_users || 0}</div>
                </div>
                <div className="bg-white/5 border border-white/10 p-4 rounded-2xl">
                    <span className="text-gray-400 text-xs uppercase">حالة الـ KV</span>
                    <div className="text-lg font-bold text-green-400 mt-1">{stats?.active_sessions}</div>
                </div>
            </div>

            {/* Rare Parts Requests */}
            <div className="bg-charcoal-light/50 border border-white/10 rounded-3xl p-6 mt-4">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-bold text-white">طلبات القطع النادرة</h3>
                    <button onClick={fetchData} className="text-xs text-primary hover:underline">تحديث</button>
                </div>

                <div className="overflow-x-auto">
                    <table className="w-full text-right text-sm">
                        <thead className="text-gray-400 border-b border-white/10">
                            <tr>
                                <th className="pb-3 px-2">التاريخ</th>
                                <th className="pb-3 px-2">الموديل</th>
                                <th className="pb-3 px-2">القطعة</th>
                                <th className="pb-3 px-2">الحالة</th>
                            </tr>
                        </thead>
                        <tbody className="text-white">
                            {requests.map((req) => (
                                <tr key={req.id} className="border-b border-white/5 hover:bg-white/5 transition-colors">
                                    <td className="py-3 px-2 text-xs text-gray-400">{new Date(req.created_at).toLocaleDateString()}</td>
                                    <td className="py-3 px-2">{req.vehicle_model}</td>
                                    <td className="py-3 px-2">{req.part_name}</td>
                                    <td className="py-3 px-2">
                                        <span className="px-2 py-1 bg-amber-500/20 text-amber-500 rounded-md text-[10px] font-bold">قيد البحث</span>
                                    </td>
                                </tr>
                            ))}
                            {requests.length === 0 && (
                                <tr>
                                    <td colSpan={4} className="py-8 text-center text-gray-500">لا توجد طلبات حالياً</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
